import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font
} from '@react-pdf/renderer';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingTop: '15%',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  text: {
    fontSize: 10
  },
  textUnderlined: {
    fontSize: 10,
    textDecoration: 'underline'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'ultrabold',
    marginBottom: 10,
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    marginLeft: '28%',
    alignItems: 'flex-start',
    gap: 40,
    width: '75vw',
    border: '1px solid black',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '10px',
    paddingBottom: '10px',
    borderRadius: '10px'
  },

  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 40,
    width: '90vw',
    paddingLeft: '10px',
    paddingRight: '20px',
    paddingBottom: '10px',
    borderRadius: '10px',
    marginTop: '0.5%',
    marginLeft: 0
  },
  column1: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegisterationPDF = ({ data }) => {
  console.log('HELLO REG NO,', data);
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const ageString = data.age;
  const years = ageString.match(/\d+Y/); // This will match digits followed by "Y"

  function convertTo12HourFormat(time24) {
    // Split the time into hours and minutes
    let [hours, minutes] = time24.split(':').map(Number);

    // Determine AM or PM
    const period = hours < 12 ? 'AM' : 'PM';

    // Convert hours to 12-hour format
    hours = hours % 12 || 12; // If hours is 0 (midnight), set to 12

    // Format the time string
    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
  }
  return (
    <>
      <div style={fullScreenStyles.container}>
        <PDFViewer width="100%" height="100%" showToolbar>
          <Document title={`${data.name} Registration`}>
            <Page size="A4" style={styles.page}>
              <View style={styles.row}>
                <Text content="Date/Time     - " style={{ fontSize: 10, marginLeft: '70%' }} />
                <Text content={`${formatDate(data?.reg_date)} ${convertTo12HourFormat(data?.reg_time)}`} />
              </View>
              <View style={{ position: 'relative' }}>
                <View
                  style={{
                    ...styles.contentContainer,
                    position: 'absolute', // Float above other content
                    zIndex: 10, // Bring it to the foreground
                    backgroundColor: 'white', // Ensure readability
                    padding: 10,
                    borderRadius: 5, // Optional: Add some rounded corners for design consistency
                    shadowColor: '#000', // Optional: Add shadow for better visibility
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.25,
                    shadowRadius: 3.84,
                    elevation: 5 // Android-specific shadow property
                  }}
                >
                  <View style={styles.column}>
                    <View style={styles.row}>
                      <Text content="Patient Name  :  " style={{ fontSize: 10 }} />
                      <Text content={`${data.name}`} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Address          :  " style={{ fontSize: 10 }} />
                      <Text content={`${data.address}`} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Consultant      :  " style={{ fontSize: 10 }} />
                      <Text content={`${data.consultant}`} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Mobile No.      :  " style={{ fontSize: 10 }} />
                      <Text content={`${data.mobile}`} />
                    </View>
                  </View>
                  <View style={styles.column}>
                    <View style={styles.row}>
                      <Text content="UHID NO.        :  " style={{ fontSize: 10, fontWeight: 'bold' }} />
                      <Text content={`${data.uhid}`} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Age/Sex          :  " style={{ fontSize: 10 }} />
                      <Text content={`${years} / ${data.gender}`} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Department     :  " style={{ fontSize: 10 }} />
                      <Text content={`${data.department}`} />
                    </View>
                    <View style={styles.row}>
                      <Text content="OPD Type       :  " style={{ fontSize: 10 }} />
                      <Text content={`${data.opd_type}`} />
                    </View>
                  </View>
                </View>

                <View
                  style={{
                    ...styles.contentContainer2,
                    zIndex: 5,
                    marginLeft: 0,
                    paddingLeft: 0,
                    marginRight: 50,
                    position: 'relative',
                    top: '-3%'
                  }}
                >
                  <View style={{ ...styles.column, border: '1px solid black', gap: 6, padding: '6px' }}>
                    <View style={styles.row}>
                      <Text
                        content="INVESTIGATION"
                        style={{ fontSize: 10, textDecoration: 'underline', fontFamily: 'Roboto' }}
                      />
                    </View>
                    <View style={styles.row}>
                      <Text content="HB/TLC/DLC" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="CBC" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="ESR" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Blood Sugar F/PP/R" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="HbA1C" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Blood Urea" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="S. Creatinine" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="S. Uric Acid" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="S. Bilirubin (T / D)" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="S.G.O.T/S.G.P.T." style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="LFT" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="KFT" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="RA Factor" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="CRP" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Vitamin B12/Vit.D" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Lipid Profile" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Blood Group" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Urine R/M" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="T3, T4, TSH" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Viral / Makers " style={{ fontSize: 10 }} />
                      <Text content="(Hep-B / Hep-C / HIV)" style={{ fontSize: 7 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="X-Ray" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="USG Abdomen" style={{ fontSize: 10 }} />
                      <Text content="(Upper / Lower / Whole)" style={{ fontSize: 7 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="BT/CT" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="VDRL" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="PT/INR" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="PSA" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Typhidot (IGG / IGM)" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Dengue Serology" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Malaria Parasite Antigen" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="AEC" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="CT-Scan" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Echo" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="ECG" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="MRI" style={{ fontSize: 10 }} />
                      <Text content="(Screening / Lumber / Cervical)" style={{ fontSize: 7 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Mantoux Test" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Sputum AFB" style={{ fontSize: 10 }} />
                    </View>
                  </View>
                  <View style={{ ...styles.column1, marginTop: '15%', position: 'relative', left: '-10%' }}>
                    <View style={styles.row}>
                      <Text content="Chief Complaints" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="History" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="General Physical Examination" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Provisional" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="TREATMENT PLAN" style={{ fontSize: 10 }} />
                    </View>
                  </View>

                  <View
                    style={{
                      ...styles.column,
                      border: '1px solid black',
                      padding: '10px',
                      borderRadius: '5px',
                      marginTop: '15%',
                      position: 'relative',
                      right: '-10%'
                    }}
                  >
                    <View style={styles.row}>
                      <Text content="BP      :" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Pulse  :       " style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="SP02  :  " style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Temp  :  " style={{ fontSize: 10 }} />
                    </View>
                  </View>
                </View>

                <View style={{ ...styles.row, marginLeft: '35%' }}>
                  <Text
                    content="For further follow-up attend your doctor’s OPD on due date and time 
In case of emergency attend hospital casualty. never consultation on telephone  "
                    style={{ fontSize: 10 }}
                  />
                </View>
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </div>
    </>
  );
};
